"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _htmlToReact = require("html-to-react");

var _propTypes = require("prop-types");

var HtmlRender = function HtmlRender(_ref) {
  var htmlToRender = _ref.htmlToRender,
      processingInstructions = _ref.processingInstructions;
  // Order matters. Instructions are processed in the order they're defined
  var htmlToReactParser = new _htmlToReact.Parser();
  var reactComponent = htmlToReactParser.parseWithInstructions(htmlToRender || '<div></div>', function () {
    return true;
  }, processingInstructions);
  return reactComponent;
};

HtmlRender.propTypes = {
  htmlToRender: _propTypes.string,
  processingInstructions: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})).isRequired
};
HtmlRender.defaultProps = {
  htmlToRender: null
};
var _default = HtmlRender;
exports.default = _default;